import React, { Component } from "react";

import { Fragment } from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
// core components
import Select from "react-select";
import Card from "@material-ui/core/Card";
import ImageUpload from "../../../components/CustomUpload/ImageUpload.jsx";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import TextField from "@material-ui/core/TextField";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import {
  FormControl,
  // Input,
  // MenuItem,
  InputLabel,
  // Tooltip,
  // Switch
} from "@material-ui/core";
// import InputLabel from "@material-ui/core/InputLabel";
import GridItem from "components/Grid/GridItem.jsx";
import SimpleReactValidator from "simple-react-validator";

import toastr from "toastr";
import { hist } from "../../..";

import axios from "../../../config/axios";
// import { getAllCategories$ } from "../../../redux/actions/category.js";
// import { getAllSpeakers$ } from "../../../redux/actions/speaker.js";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// import { Editor } from "react-draft-wysiwyg";
// import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import moment from "moment";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
// import {
//   EditorState,
//   ContentState,
//   convertFromHTML,
//   convertToRaw
// } from "draft-js";
// import draftToHtml from "draftjs-to-html";
import loaderIcon from "assets/img/loader.gif";

toastr.options = {
  closeButton: true
};

const validationStyle = {
  color: "red"
};

const addButtonProps = {
  color: "rose",
  round: true
};
const changeButtonProps = {
  color: "rose",
  round: true
};
const removeButtonProps = {
  color: "danger",
  round: true
};
// const formStyle = {
//   minWidth: 300,
//   margin: "0 1.2rem 1.2rem 0"
// };

class AddEvent extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      action: "add",
      image: null,
      topic: null,
      date: new Date().getTime(),
      start_date: null,
      start_time: null,
      duration: null,
      VIPseats: null,
      normalSeats: null,
      waitingSeats: null,
      agenda: null,
      loading: false,
      selectedDate: null,
      eventType: [{
        "label": "Recurring",
        "value": "9"
      },
      {
        "label": "One time ",
        "value": "5"
      }
      ],
      event_name: null,
      webinar_image: null,
      id: null,
      maxParticipants: null,
      group_booking_price:null,
      student_price:null,
      normal_price:null,
      early_bird_price:null,
      expiry_date: null,
      expiry_time:null,
      webinarType: [
        {
          value: "Free",
          label: "Free"
        },
        {
          value: "Paid",
          label: "Paid"
        }
      ],
      event_type: "",
    };
  }

  componentDidMount() {

    axios
      .get("zoom/zoomWebinarSubscriptionPlan")
      .then(res => {
        if (res.status === 200 || res.status === 201) {
          let response = res.data.data;
          this.setState({
            maxParticipants: response
          })
          // debugger;
          // toastr.success("Webinar Created Successfully!");
          // setTimeout(() => hist.goBack(), 1000);
        }
      })
      .catch(error => {
        // this.setState({ loading: false });
        if (error.response) {
          toastr.error(error.response.data.message);
        }

      });
    if (this.props && this.props.location && this.props.location.state) {

      const { webinar } = this.props.location.state;
      // debugger;
      let {
        id,
        // host_email,
        agenda,
        // created_at,
        duration,
        topic,
        vip_seats,
        waiting_seats,
        type,
        normal_seats,
        // status,
        start_time,
        webinar_images,
        group_booking_price,
        student_price,
        normal_price,
        early_bird_price,
        expiry_date,
        webinar_type,
        start_date
      } = webinar;
      let date = moment(new Date(start_date), "LLL");
      let pic = webinar_images[0].path;
      let event_name;
      if (type === 5) {
        event_name = {
          "label": "One time",
          "value": "5"
        }
      } else {
        event_name = {
          "label": "Recurring",
          "value": "9"
        }
      }
      this.setState({
        id,
        action: "edit",
        topic,
        date: new Date().getTime(),
        start_date: start_time,
        selectedDate: date,
        duration,
        VIPseats: vip_seats,
        normalSeats: normal_seats,
        waitingSeats: waiting_seats,
        agenda,
        webinar_image: pic,
        event_name,
        group_booking_price,
        student_price,
        normal_price,
        early_bird_price,
        expiry_date: moment(new Date(expiry_date), "LLL"),
        event_type: {
          value: webinar_type,
          label: webinar_type
        }
      })

    }
  }

  componentDidUpdate(prevProps) {


  }

  inputHandler = event => {
    
    const { name, value } = event.target;
    if (name === "agenda" && value.length > 2000) {
      return toastr.error("You have exceeded the length")
    }

    if (name === "VIPseats" && value.length > 3) {
      return toastr.error("Only 3 digits are allowed!")
    }
    if (name === "normalSeats" && value.length > 3) {
      return toastr.error("Only 3 digits are allowed!")
    }
    if (name === "waitingSeats" && value.length > 3) {
      return toastr.error("Only 3 digits are allowed!")
    }
    if (name === "duration" && value > 1440) {
      return toastr.error("As per plan only 1440 mins are allowed!")
    }

    this.setState({ [name]: value });
  };

  submitForm = () => {
    // console.log(this.state,'submit form');
    let { 
      topic,
      start_date,
      start_time,
      duration,
      agenda,
      VIPseats,
      normalSeats,
      waitingSeats, event_name, image, action, webinar_image, maxParticipants,
      group_booking_price,
      student_price,
      normal_price,
      early_bird_price,
      expiry_time,
      event_type,
      expiry_date } = this.state;

    // let maxCount = VIPseats.concat(normalSeats, waitingSeats);
    // if (maxCount > maxParticipants) {
    //   debugger;
    //   return toastr.error(`Maximum Participants can be ${maxParticipants}!`);
    // }
    debugger;
    this.setState({ loading: true });
    if (this.validator.allValid()) {
      let requestBody={
        topic,
        "type": event_name.value,
        start_time,
        start_date,
        duration,
        agenda,
        "normal_seats": normalSeats,
        "vip_seats": VIPseats,
        "waiting_seats": waitingSeats,
        "webinar_images": [{ "path": webinar_image }],
        webinar_type: event_type.value,
        group_booking_price,
        student_price,
        normal_price,
        early_bird_price,
        expiry_date:  expiry_time ? expiry_time: expiry_date
      };
      if (action === "edit") {
        requestBody.id=this.state.id;
        }

      let totalSeats = parseInt(normalSeats) + parseInt(VIPseats) + parseInt(waitingSeats);
      if (maxParticipants < totalSeats) {
        this.setState({ loading: false });
        return toastr.error("Seats are greater than participants!");
      }
      if (action === "add") {
        axios
          .post("zoom/createWebinar?host_email=zoom@affle.com", requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {
              toastr.success("Webinar Created Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => {
            this.setState({ loading: false });
            if (error.response) {
              toastr.error(error.response.data.message);
            }

          });
      } else {

        axios
          .post("zoom/UpdateWebinarByAdmin", requestBody)
          .then(res => {
            if (res.status === 200 || res.status === 201) {

              toastr.success("Webinar Updated Successfully!");
              setTimeout(() => hist.goBack(), 1000);
            }
          })
          .catch(error => {
            this.setState({ loading: false });
            if (error.response) {
              toastr.error(error.response.data.message);
            }
          });
      }
    } else {
      this.setState({ loading: false });
      this.validator.showMessages();
      this.forceUpdate();
    }

  };

  fileUploadHandler = file => {
    let form = new FormData();
    form.append("image", file);
    axios
      .post("storage/event/upload-file", form)
      .then(res => {
        if (res.status === 200 || res.status === 201) {

          this.setState({ webinar_image: res.data.data[0] });
        }
      })
      .catch(error => {
        if (error.response) {
          toastr.error(error.response.data.message);
        } else {
          toastr.error("Please upload image again!");
        }
      });
  };

  uploadImageCallBack = file => {
    return new Promise((resolve, reject) => {
      let form = new FormData();
      form.append("image", file);
      axios
        .post("storage/event/upload-file", form)
        .then(res => {
          // console.log(res.data.data[0]);
          // console.log(typeof res.data.data[0]);
          if (res.status === 200 || res.status === 201) {
            resolve({ data: { link: res.data.data[0] } });
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  };

  render() {
    // const { classes } = this.props;

    const {
      topic,
      action,
      start_date, image, agenda, webinar_image, eventType, event_name, selectedDate, loading, date, VIPseats, normalSeats, waitingSeats, duration,   group_booking_price,
      student_price,
      start_time,
      normal_price,
      early_bird_price,
      expiry_date,
      expiry_time,
      event_type,

      webinarType
    } = this.state;
    // console.log("state", this.state);
    // var today = new Date().toISOString();
    // var todayDate = today.substring(0, today.length - 8);

    return (
      <div className="add-category-form webinar">
        <Card
          // className={classes.card}
          style={{ overflow: "-webkit-paged-x" }}
        >
          {loading ? (
            <div className="loader_icon">
              <img src={loaderIcon} alt="loader"/>
            </div>
          ) : (
              <React.Fragment>
                <CardContent>
                  <form>
                    <GridContainer>
                    <GridItem md={12}>
                        <FormControl
                          // className={classes.formControl}
                          fullWidth
                          style={{ margin: "0.7rem 0" }}
                        >
                          <legend style={{ fontSize: "1rem" }}>Webinar Type</legend>
                          <Select
                            name="event_type"
                            options={webinarType}
                            value={event_type}
                            onChange={(inputValue, actionMeta) => {
                              if (inputValue) {
                                this.setState({
                                  event_type: inputValue
                                });
                              }
                            }}
                            className="basic-multi-select"
                            classNamePrefix="select"
                          />
                        </FormControl>
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "event_type",
                              event_type,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: topic ? true : false
                          }}
                          autoFocus
                          margin="dense"
                          id="topic"
                          name="topic"
                          label="Topic*"
                          type="text"
                          fullWidth
                          value={topic}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Topic Name",
                              topic,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>

                      <GridItem
                        md={12}
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        style={{ marginTop: "20px" }}
                      >
                        <legend>Webinar Image</legend>
                        
                        {
                        action === "edit"
                         ?
                          <ImageUpload
                            className="image_upload"
                            currentProduct={
                              { image: webinar_image }
                            }
                            size="700*465"
                            uploadImage={this.fileUploadHandler}
                            addButtonProps={addButtonProps}
                            changeButtonProps={changeButtonProps}
                            removeButtonProps={removeButtonProps}
                          /> : <ImageUpload
                            className="image_upload"
                            currentProduct={
                              image !== null
                                ? { image: webinar_image }
                                : { image: "" }
                            }
                            size="700*465"
                            uploadImage={this.fileUploadHandler}
                            addButtonProps={addButtonProps}
                            changeButtonProps={changeButtonProps}
                            removeButtonProps={removeButtonProps}
                          />}
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "webinar Image",
                              webinar_image,
                              "required"
                            )}
                          </span>
                        }
                        <span>
                          Please upload image with 700 x 465 resolution having
                          JPEG, PNG, JPG format and Max size is 2mb
                      </span>
                      </GridItem>

                      {action === "edit" 
                      ? (
                        <GridItem md={12}>
                          <FormControl
                            // className={classes.formControl}
                            fullWidth
                            style={{ margin: "0.7rem 0" }}
                          >
                            <legend style={{ fontSize: "1rem" }}>Event Type</legend>
                            <Select

                              name="category"
                              options={eventType}
                              value={event_name}
                              isDisabled={true}
                              onChange={(inputValue, actionMeta) => {
                                if (inputValue) {
                                  this.setState({
                                    event_name: inputValue
                                  });
                                }
                              }}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </FormControl>
                          {
                            <span style={validationStyle}>
                              {this.validator.message(
                                "Event Type",
                                event_name,
                                "required"
                              )}
                            </span>
                          }
                        </GridItem>
                      )
                       : <GridItem md={12}>
                          <FormControl
                            // className={classes.formControl}
                            fullWidth
                            style={{ margin: "0.7rem 0" }}
                          >
                            <legend style={{ fontSize: "1rem" }}>Event Type</legend>
                            <Select

                              name="category"
                              options={eventType}
                              value={event_name}
                              onChange={(inputValue, actionMeta) => {
                                if (inputValue) {
                                  this.setState({
                                    event_name: inputValue
                                  });
                                }
                              }}
                              className="basic-multi-select"
                              classNamePrefix="select"
                            />
                          </FormControl>
                          {
                            <span style={validationStyle}>
                              {this.validator.message(
                                "Event Type",
                                event_name,
                                "required"
                              )}
                            </span>
                          }
                        </GridItem>}



                      <GridItem className="date_text" md={6}>
                        <InputLabel shrink={true}>
                          Start Date &amp; Time
                      </InputLabel>
                        <DatePicker
                          selected={selectedDate}
                          showTimeSelect={true}
                          dateFormat="LLL"
                          // timeIntervals={10}
                          onChange={date => {
                            // console.log(new Date(date).getTime());
                            // let maxdate = moment(date).add("days", 1);
                            let toISOString = date.toISOString();
                            // let val = new Date(date.toISOString())
                  
                            let utcStart = moment.utc(date).format()
                     
                            console.log(
                              utcStart,
                              'dateee'
                              )
                            
                            if (
                              new Date(date).getDate() === new Date().getDate() &&
                              new Date(date).getMonth() ===
                              new Date().getMonth() &&
                              new Date(date).getFullYear() ===
                              new Date().getFullYear()
                            ) {
                              if (
                                moment(new Date(date)).hour() * 60 +
                                moment(new Date(date)).minute() >=
                                moment(new Date()).hour() * 60 +
                                moment(new Date()).minute()
                              ) {
                                this.setState({
                                  start_date: toISOString,
                                  start_time : utcStart,
                                  selectedDate: date

                                });
                              } else {
                                this.setState({ start_date: null,start_time:null });
                                toastr.error("Cant select past time.");
                              }
                            } else {
                              this.setState({
                                start_date: toISOString,
                                start_time : utcStart,
                                selectedDate: date
                              });
                            }
                          }}
                          minDate={new Date()}
                          placeholderText="Select Start Date"
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Start Date & Time",
                              start_date,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>

                      <GridItem md={6}>
                        <TextField
                          InputLabelProps={{
                            shrink: duration ? true : false,
                            pattern: "{1,15}"
                          }}
                          margin="dense"
                          id="duration"
                          name="duration"
                          label="Duration (mins)*"
                          type="number"
                          fullWidth
                          value={duration}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Duration",
                              duration,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>


                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: agenda ? true : false
                          }}
                          margin="dense"
                          id="agenda"
                          name="agenda"
                          label="Agenda (description)*"
                          type="text"
                          multiline={true}
                          fullWidth
                          value={agenda}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Agenda",
                              agenda,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>
                      {event_type.value === "Paid" ? (<Fragment>
                      <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: group_booking_price ? true : false
                              }}
                              margin="dense"
                              id="group_booking_price"
                              name="group_booking_price"
                              label="Group Booking Price*"
                              type="number"
                              fullWidth
                              value={group_booking_price}
                              onChange={event => {
                                this.inputHandler(event);
                              }}
                            />
                            {
                              <span style={validationStyle}>
                                {this.validator.message(
                                  "Group Booking Price",
                                  group_booking_price,
                                  "required"
                                )}
                              </span>
                            }
                          </GridItem>
                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: student_price ? true : false
                              }}
                              margin="dense"
                              id="student_price"
                              name="student_price"
                              label="Student Price*"
                              type="number"
                              fullWidth
                              value={student_price}
                              onChange={event => {
                                this.inputHandler(event);
                              }}
                            />
                            {
                              <span style={validationStyle}>
                                {this.validator.message(
                                  "Student Price",
                                  student_price,
                                  "required"
                                )}
                              </span>
                            }
                          </GridItem>
                          <GridItem md={12}>
                            <TextField
                              InputLabelProps={{
                                shrink: normal_price ? true : false
                              }}
                              margin="dense"
                              id="normal_price"
                              name="normal_price"
                              label="Normal Price*"
                              type="number"
                              fullWidth
                              value={normal_price}
                              onChange={event => {
                                this.inputHandler(event);
                              }}
                            />
                            {
                              <span style={validationStyle}>
                                {this.validator.message(
                                  "Normal Price",
                                  normal_price,
                                  "required"
                                )}
                              </span>
                            }
                          </GridItem>
                          <div className="two_cols">
                          <GridItem md={6}>
                            <TextField
                              InputLabelProps={{
                                shrink: early_bird_price ? true : false
                              }}
                              margin="dense"
                              id="early_bird_price"
                              name="early_bird_price"
                              label="Early Bird Price*"
                              type="number"
                              fullWidth
                              value={early_bird_price}
                              onChange={event => {
                                this.inputHandler(event);
                              }}
                            />
                            {
                              <span style={validationStyle}>
                                {this.validator.message(
                                  "Early Bird Price",
                                  early_bird_price,
                                  "required"
                                )}
                              </span>
                            }
                          </GridItem>
                          <GridItem className="date_text" md={6}>
                        <InputLabel shrink={true}>Early Bird Expiry Date &amp; Time</InputLabel>
                        <DatePicker
                          selected={expiry_date}
                          onChange={date => {    
                            let toISOString = date.toISOString();
                            this.setState({
                              expiry_time: toISOString,
                              expiry_date: date
                            })
                          }}
                          
                          showTimeSelect={true}
                          dateFormat="LLL"
                          // maxDate={setMaxDate}
                          minDate={new Date()}
                          placeholderText="Select Date"
                        />

                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "expiry_date",
                              expiry_date,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>
                      </div>
                      </Fragment>
                          ):null}
                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: VIPseats || VIPseats === 0 ? true : false,
                            pattern: "{1,15}"
                          }}
                          margin="dense"
                          id="VIPseats"
                          name="VIPseats"
                          label="Reserved seat for VIP*"
                          type="number"

                          fullWidth
                          value={VIPseats}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "vip seats",
                              VIPseats,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>

                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: normalSeats || normalSeats  === 0  ? true : false,
                            pattern: "{1,15}"
                          }}
                          margin="dense"
                          id="normalSeats"
                          name="normalSeats"
                          label="Normal User Seats*"
                          type="number"

                          fullWidth
                          value={normalSeats}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Normal Seats",
                              normalSeats,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>



                      <GridItem md={12}>
                        <TextField
                          InputLabelProps={{
                            shrink: waitingSeats || waitingSeats  === 0  ? true : false,
                            pattern: "{1,15}"
                          }}
                          margin="dense"
                          id="waitingSeats"
                          name="waitingSeats"
                          label="No. of seats available in waiting*"
                          type="number"
                          fullWidth
                          value={waitingSeats}
                          onChange={event => {
                            this.inputHandler(event);
                          }}
                        />
                        {
                          <span style={validationStyle}>
                            {this.validator.message(
                              "Waiting Seats",
                              waitingSeats,
                              "required"
                            )}
                          </span>
                        }
                      </GridItem>

                      {/* <GridItem>
                      <span>Can be Cancelled</span>
                      <Tooltip title="Toggle Status">
                        <Switch
                          checked={
                            cancelled
                            // this.state.ProductList[serial_number.index].is_active
                          }
                          onClick={e => {
                            e.stopPropagation();
                            this.setState({
                              cancelled: !cancelled
                            });
                          }}
                        />
                      </Tooltip>
                    </GridItem> */}

                    </GridContainer>
                  </form>
                </CardContent>
                <CardActions style={{ float: "right" }}>
                  <Button
                    variant="contained"
                    color="iseas"
                    onClick={this.submitForm}
                  >
                    Submit
                </Button>
                </CardActions>
              </React.Fragment>
            )}
        </Card>
      </div>
    );
  }
}

// const mapStateToProps = state => {
//   return {
//     categoryListData: state.category,
//     speakerListData: state.speaker
//   };
// };

// const mapDispatchToProps = dispatch => {
//   return {
//     handleGetCategoryList: () => dispatch(getAllCategories$.trigger()),
//     handleGetSpeakerList: () => dispatch(getAllSpeakers$.trigger())
//   };
// };

export default connect()(withStyles(extendedFormsStyle)(AddEvent));



// WEBPACK FOOTER //
// ./src/views/ISEAS/WebinarManagement/AddEvent.js